module.exports = __webpack_public_path__ + "img/D5B5B4_9E6C6F_F5E9EF_A57986-256px.c0df8149.png";